import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useToggleMenuStore = create(
  persist(
    (set) => ({
      isToggleMenu: true,
      setIsToggleMenu: (isToggleMenu) => {
        set({
          isToggleMenu,
        });
      },
    }),
    {
      name: "toggle-menu-storage",
      partialize: (state) => ({
        isToggleMenu: state.isToggleMenu,
      }),
    },
  ),
);

export const useRightOrgProfileStore = create((set) => ({
  orgRole: [],
  isLoadingOrg: true,
  setOrgRole: (orgRole) => {
    set({
      orgRole,
    });
  },
  setIsLoadingOrg: (isLoadingOrg) => {
    set({
      isLoadingOrg,
    });
  },
}));

export const useOrgSeleteStore = create(
  persist(
    (set) => ({
      orgSelete: null,
      setOrgSelete: (orgSelete) => {
        set({
          orgSelete,
        });
      },
    }),
    {
      name: "org-menu-storage",
      partialize: (state) => ({
        orgSelete: state.orgSelete,
      }),
    },
  ),
);

export const useMenuLayoutStore = create((set) => ({
  menuLayout: [],
  isLoading: false,
  setIsLoading: (isLoading) => {
    set({
      isLoading,
    });
  },
  setMenuLayout: (menuLayout) => {
    set({
      menuLayout,
    });
  },
}));

export const useSubMenuListStore = create((set) => ({
  selectSubMenu: null,
  setSelectSubMenu: (selectSubMenu) => {
    set({
      selectSubMenu,
    });
  },
}));

export const useApiVersionStore = create((set) => ({
  apiVersion: null,
  setApiVersion: (apiVersion) => {
    set({
      apiVersion,
    });
  },
}));

export const useIsShowMenuListStore = create((set) => ({
  showMenu: false,
  setShowMenu: (showMenu) => {
    set({
      showMenu,
    });
  },
}));

export const useLanguageStage = create(
  persist(
    (set) => ({
      languageStage: "en",
      setLanguageStage: (languageStage) => set({ languageStage }),
      reset: () => set({ languageStage: "en" }),
    }),
    {
      name: "language-storage",
      partialize: (state) => ({
        languageStage: state.languageStage,
      }),
    },
  ),
);
